import { render } from "./PayrollList.vue?vue&type=template&id=2bb99fd5"
import script from "./PayrollList.vue?vue&type=script&lang=js"
export * from "./PayrollList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\payroll-system\\dashboards\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__